var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSingapore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 37.5001C0.25 16.7895 17.0395 0 37.75 0C58.4605 0 75.25 16.7895 75.25 37.5001",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.076 19.565C23.076 14.1014 26.9158 9.53726 32.0433 8.41738C31.2552 8.24541 30.4377 8.1521 29.5976 8.1521C23.2942 8.1521 18.1846 13.2618 18.1846 19.5651C18.1846 25.8685 23.2942 30.9782 29.5976 30.9782C30.4374 30.9782 31.2551 30.8849 32.0433 30.7127C26.9158 29.5929 23.076 25.0287 23.076 19.565Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7499 8.96729L38.5594 11.4583H41.1787L39.0595 12.9979L39.8689 15.4889L37.7499 13.9495L35.6309 15.4889L36.4403 12.9979L34.3213 11.4583H36.9404L37.7499 8.96729Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3962 13.8586L32.2055 16.3498H34.8248L32.7058 17.8893L33.5152 20.3803L31.3962 18.8409L29.2769 20.3803L30.0865 17.8893L27.9673 16.3498H30.5866L31.3962 13.8586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1039 13.8586L44.9135 16.3498H47.5327L45.4135 17.8893L46.2231 20.3803L44.1039 18.8409L41.9849 20.3803L42.7943 17.8893L40.6753 16.3498H43.2944L44.1039 13.8586Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6581 21.1956L42.4676 23.6867H45.0867L42.9677 25.2262L43.7772 27.7172L41.6581 26.1778L39.5391 27.7172L40.3485 25.2262L38.2295 23.6867H40.8485L41.6581 21.1956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8418 21.1956L34.6512 23.6867H37.2706L35.1514 25.2262L35.961 27.7172L33.8418 26.1778L31.7227 27.7172L32.5321 25.2262L30.4131 23.6867H33.0324L33.8418 21.1956Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSingapore);
export default __webpack_public_path__ + "static/media/flagSingapore.34815dfe21252e4344fd6d9fa78498c7.svg";
export { ForwardRef as ReactComponent };